module.exports = __webpack_public_path__ + "static/img/bg1.787e3d20.png";